var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { Disposer } from "../Infra/Disposer";
import { getObservableT } from "../Infra/i18next";
import { ProjectType } from "healthex-common/study.dtos";
export class PatientResearchStudyRevokeConsentViewModel {
    constructor(props) {
        var _a;
        this.modalStudyId = null;
        this.disposer = new Disposer();
        this.t = getObservableT("patients");
        this.patientStudyConsent = NOT_LOADED;
        this.isRevokeConsentButtonLoading = false;
        this.revokeStatus = null;
        this.closeRevokeConsentDialog = () => {
            var _a;
            (_a = this.hideStudyRevokeConsentDialog) === null || _a === void 0 ? void 0 : _a.call(this);
        };
        this.studyManager = props.container.studyManager;
        this.patientConsentUIManager = props.container.patientConsentUIManager;
        this.routingUIManager = props.container.routingUIManager;
        this.authManager = props.container.authManager;
        this.modalStudyId = (_a = props.modalStudyId) !== null && _a !== void 0 ? _a : null;
        this.patientService = props.container.patientService;
        this.hideStudyRevokeConsentDialog = props.hideStudyRevokeConsentDialog;
        this.onRevokeSucceeded = props.onRevokeSucceeded;
    }
    run() {
        this.disposer.reaction(() => this.studyId, async () => {
            await this.refreshStudyConsent();
        }, { fireImmediately: true });
    }
    stop() {
        this.disposer.dispose();
    }
    get studyId() {
        var _a, _b, _c;
        return (_c = (_a = this.modalStudyId) !== null && _a !== void 0 ? _a : (_b = this.routingUIManager.currentRouteParams) === null || _b === void 0 ? void 0 : _b.studyId) !== null && _c !== void 0 ? _c : null;
    }
    get study() {
        if (!this.patientStudyConsent)
            return null;
        if (this.patientStudyConsent === NOT_LOADED)
            return null;
        if (this.patientStudyConsent === null)
            return null;
        if (this.patientStudyConsent.study === null)
            return null;
        if (this.patientStudyConsent.consents === null)
            return null;
        return { ...this.patientStudyConsent.study, consents: this.patientStudyConsent.consents };
    }
    get organizationName() {
        if (!this.study)
            return null;
        return this.study.addedByOrganization.name;
    }
    get withdrawalMessage() {
        var _a, _b;
        const organizationName = ((_a = this.study) === null || _a === void 0 ? void 0 : _a.projectType) === ProjectType.AI_DATA_USE ? (_b = this.study) === null || _b === void 0 ? void 0 : _b.aiToolName : this.organizationName;
        return this.t("If you end sharing, {{ organizationName }} stops receiving your records for this request. This won't remove records {{ organizationName }} already received.\n\nYour HealthEx Wallet isn't affected.", { organizationName });
    }
    get successWithdrawalMessage() {
        var _a, _b;
        const organizationName = ((_a = this.study) === null || _a === void 0 ? void 0 : _a.projectType) === ProjectType.AI_DATA_USE ? (_b = this.study) === null || _b === void 0 ? void 0 : _b.aiToolName : this.organizationName;
        return this.t("Your records are no longer being shared with {{ organizationName }} for this request.\n\nYour health history is still in your HealthEx Wallet — in one place, up to date, and ready to share whenever you choose.", { organizationName });
    }
    async refreshStudyConsent() {
        if (this.studyId === null)
            return;
        if (this.authManager.id === null)
            return;
        this.patientStudyConsent = await this.patientService.getPatientStudyConsent(this.authManager.id, this.studyId, true);
    }
    async revokeConsent() {
        var _a;
        if (this.study === null)
            return;
        const consentingPatientInfo = this.authManager.consentingPatientInfo;
        if (!consentingPatientInfo)
            return;
        this.isRevokeConsentButtonLoading = true;
        const expirationDate = this.patientConsentUIManager.getConsentExpirationFromStudy(this.study);
        if (expirationDate === null) {
            this.closeRevokeConsentDialog();
            return;
        }
        try {
            const study = this.study;
            await this.studyManager.optOutOfStudy(consentingPatientInfo, study, this.study.consents.map((consent) => consent.consentType), { expirationDate });
            this.revokeStatus = true;
            await ((_a = this.onRevokeSucceeded) === null || _a === void 0 ? void 0 : _a.call(this));
        }
        finally {
            this.isRevokeConsentButtonLoading = false;
        }
    }
}
__decorate([
    observable
], PatientResearchStudyRevokeConsentViewModel.prototype, "patientStudyConsent", void 0);
__decorate([
    observable
], PatientResearchStudyRevokeConsentViewModel.prototype, "isRevokeConsentButtonLoading", void 0);
__decorate([
    observable
], PatientResearchStudyRevokeConsentViewModel.prototype, "revokeStatus", void 0);
__decorate([
    computed
], PatientResearchStudyRevokeConsentViewModel.prototype, "studyId", null);
__decorate([
    computed
], PatientResearchStudyRevokeConsentViewModel.prototype, "study", null);
__decorate([
    computed
], PatientResearchStudyRevokeConsentViewModel.prototype, "organizationName", null);
__decorate([
    computed
], PatientResearchStudyRevokeConsentViewModel.prototype, "withdrawalMessage", null);
__decorate([
    computed
], PatientResearchStudyRevokeConsentViewModel.prototype, "successWithdrawalMessage", null);
